import AssignApi from "../model/AssignApi";


async function AssignTicketVM(name,id){
    console.log("in vm");
    // console.log(name);
    // console.log(id);
    let emp_id=name.split(" ")
    console.log(emp_id[emp_id.length-1]);
    console.log(id);
    // console.log(emp_id[-1]);
    let data = new FormData()
    data.append("emp_id",emp_id[emp_id.length-1])
    data.append("ticket_id",id)
    try{
    let response = await AssignApi(data) 
    return response
    }
    catch(error){
        throw error;
    }
}
export default AssignTicketVM